/* eslint-disable react-hooks/exhaustive-deps */
import { ArrowLeft, ArrowRight } from "lucide-react";
import * as motion from "motion/react-client";
import { appearanceAnimation } from "../../../utils/animations";

import girlImg from "../../../assets/home/girl-image.png";
import quoteIcon from "../../../assets/home/quote-icon.png";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const CustomerFeedbackSection = () => {
  const { t } = useTranslation();
  const [currentFeedback, setCurrentFeedback] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const customerFeedback = [
    {
      thumbnail: girlImg,
      content: t("home.customer_feedback1"),
      author: "Jin Eun-Kyung",
      country: t("home.customer_feedback1.country"),
    },
    {
      thumbnail:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80",
      content: t("home.customer_feedback2"),
      author: "David Chen",
      country: t("home.customer_feedback2.country"),
    },
    {
      thumbnail:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80",
      content: t("home.customer_feedback3"),
      author: "Sarah Williams",
      country: t("home.customer_feedback3.country"),
    },
  ];

  const handleNextFeedback = () => {
    setCurrentFeedback((prevIndex) =>
      prevIndex === customerFeedback.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrevFeedback = () => {
    setCurrentFeedback((prevIndex) =>
      prevIndex === 0 ? customerFeedback.length - 1 : prevIndex - 1
    );
  };

  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(handleNextFeedback, 3000);
      return () => clearInterval(interval);
    }
  }, [isPaused]);

  return (
    <div className="w-full h-full flex justify-center items-center lg:px-6 py-10">
      <div
        className="w-full md:w-4/5 h-full max-w-[1290px] flex justify-center items-center relative overflow-hidden"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <div
          className="flex transition-transform duration-700 ease-out gap-4"
          style={{
            transform: `translateX(calc(-${currentFeedback} * (100% + 1rem)))`,
          }}
        >
          {customerFeedback.map((feedback, index) => (
            <div
              key={index}
              className="w-full min-w-full flex max-lg:flex-col gap-4"
            >
              {/* Image */}
              {/* <motion.div
                {...appearanceAnimation("left")}
                className="lg:w-2/5 h-full max-lg:hidden rounded-3xl flex justify-center items-center custom-lazy-load "
              >
                <LazyLoadImage
                  src={feedback.thumbnail}
                  alt="CustomerImg"
                  effect="blur"
                  className="w-full h-[450px] object-cover rounded-3xl"
                />
              </motion.div> */}

              <div className="lg:w-4/5 h-full rounded-3xl bg-primary-lightyellow text-[#074799] flex flex-col justify-start items-center">
                <div className="md:p-6 p-4 text-wrap">
                  <div className="w-full flex justify-start mb-4">
                    <img src={quoteIcon} alt="quote-icon" className="w-12" />
                  </div>

                  <motion.p
                    {...appearanceAnimation("right")}
                    className="px-2 xl:text-2xl lg:text-xl md:text-lg text-base xl:leading-relaxed text-justify"
                  >
                    {feedback.content}
                  </motion.p>
                </div>

                <div className="border-b border-[#074799] lg:w-[75%] w-[50%] my-4"></div>

                <div className="w-full flex flex-col items-end px-10 pb-6">
                  <motion.p
                    {...appearanceAnimation("left")}
                    className="xl:text-[22px] lg:text-lg text-base font-bold"
                  >
                    {feedback.author} - {feedback.country}
                  </motion.p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="absolute lg:bottom-6 max-lg:top-2 right-8 flex lg:gap-5 gap-3 text-primary-blue">
          <div
            className="rounded-full bg-white lg:p-5 p-3 cursor-pointer hover:text-white hover:bg-primary-blue duration-300"
            onClick={handlePrevFeedback}
          >
            <ArrowLeft size={24} />
          </div>
          <div
            className="rounded-full bg-white lg:p-5 p-3 cursor-pointer hover:text-white hover:bg-primary-blue duration-300"
            onClick={handleNextFeedback}
          >
            <ArrowRight size={24} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerFeedbackSection;
